import { MapTo } from '@adobe/aem-react-editable-components';
import PopularCards, { PopularCardsEditConfig } from './PopularCards';

export default MapTo('cob-corp-acquisition/components/creditonebank/popular-cards')(PopularCards, PopularCardsEditConfig);